module.exports = __webpack_public_path__ + "img/stop_contract.e08379d8.svg";